<template>
    <div class="container">
        <div class="row" style="margin:3rem 0;">
            <div class="col-xs-12 text-left">
                <router-link :to="{ name: 'Home' }">&#60; Kembali</router-link>
            </div>
            <div class="col-xs-12 text-left">
                <h3>INFO TUKANG</h3>
            </div>
            <div class="col-xs-12 col-lg-7" style="padding-bottom:1rem;">
                Dapatkan Info tentang tukang, Jenis Keahlian dan pemesanan
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-xs-12 col-md-12" style="padding-bottom:0.5rem;">
                        <select class="form-select" v-model="iskec" @change="this.iskel = ''">
                            <option value="" selected>Pilih Kecamatan</option>
                            <option v-for="kecdata in kecamatan" v-bind:key="kecdata" :value="kecdata.namakec"> {{
                                kecdata.namakec }} </option>
                        </select>
                    </div>
                    <!-- <div class="col-xs-12 col-md-6">
                    <select class="form-select" v-model="iskel">
                        <option value="" selected>Pilih Kelurahan</option>
                        <option v-for="keldata in mycond(iskec)" v-bind:key="keldata" :value="keldata.namakel"> {{ keldata.namakel }} </option>
                    </select>
                </div> -->
                </div>
            </div>
        </div>
        <div class="row" style="padding-bottom:8rem;">
            <div class="col-xs-12 col-lg-6" style="padding-bottom:2rem;" v-for="tukangdata in tukang"
                v-bind:key="tukangdata" :class="[itregex(iskec, tukangdata, iskel) == true ? 'col-xs-12 col-lg-6' : '']"
                :style="[itregex(iskec, tukangdata, iskel) == true ? '' : { 'display': 'none' }]">
                <div class="row" v-if="itregex(iskec, tukangdata, iskel) == true">
                    <div class="col-4" align="center">
                        <img :src="base_url + 'tenaga-kerja/' + tukangdata.id + '/photo'" class="img-thumbnail"
                            style="width:100px;height:100px">
                    </div>
                    <div class="col-8">
                        <table border="0" style="width:100%;">
                            <tr style="line-height:1.2rem;font-size:1rem;">
                                <td style="width:25%;vertical-align: top;text-align:left;"><b>Nama</b></td>
                                <td style="width:10%;vertical-align: top;text-align:left;">:</td>
                                <td style="width:65%;">{{ tukangdata.nama }}</td>
                            </tr>
                            <tr style="line-height:1.2rem;font-size:1rem;">
                                <td style="width:25%;vertical-align: top;text-align:left;"><b>Bidang</b></td>
                                <td style="width:10%;vertical-align: top;text-align:left;">:</td>
                                <!-- <td style="width:65%;">{{ tukangdata.bidang_konstruksi }}</td> -->
                                <td style="width:65%;">
                                    <ul style="padding: 0px;">
                                    <li v-for="tkskill in tukangdata.listTenagaKerjaSkills" v-bind:key="tkskill">
                                        {{ tkskill.skill.nama_sub_bidang }} 
                                    </li>
                                    </ul>
                                    <!-- {{ tukangdata.listTenagaKerjaSkills }} -->
                                </td>
                            </tr>
                            <tr style="line-height:1.2rem;font-size:1rem;">
                                <td style="width:25%;vertical-align: top;text-align:left;"><b>Wilayah</b></td>
                                <td style="width:10%;vertical-align: top;text-align:left;">:</td>
                                <td style="width:65%;">{{ loadwil(tukangdata.kelurahan) + ', ' + loadwil(tukangdata.kecamatan)
                                }}</td>
                            </tr>
                            <tr style="line-height:1.2rem;font-size:1rem;">
                                <td style="width:25%;vertical-align: top;text-align:left;"><b>Sertifikat</b></td>
                                <td style="width:10%;vertical-align: top;text-align:left;">:</td>
                                <td style="width:65%;">
                                    <ol id="isol">
                                        <li class="loops" v-for="sertifikat in tukangdata.list_sertifikat"
                                            v-bind:key="sertifikat">{{ sertifikat.nomor }}</li>
                                        <li class="lose" v-if="tukangdata.list_sertifikat.length == 0">Dalam Proses</li>
                                    </ol>
                                </td>
                            </tr>
                            <tr style="line-height:1.2rem;font-size:1rem;">
                                <td colspan="3">
                                    <!-- <img src="@/assets/icon-star.png" width="20" height="20" style="margin:0 0.1rem;" v-for="n in tukangdata.rating" v-bind:key="n"> -->
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#isol {
    counter-reset: item;
    margin-left: 0;
    padding-left: 0;
}

.loops {
    display: block;
    margin-bottom: .5em;
    margin-left: 2em;
}

.loops::before {
    display: inline-block;
    content: counter(item) ") ";
    counter-increment: item;
    width: 2em;
    margin-left: -2em;
}

.lose {
    display: block;
    margin-bottom: .5em;
    margin-left: 2em;
}

.lose::before {
    /* display: inline-block; */
    content: "";
    counter-increment: item;
    width: 2em;
    margin-left: -2em;
}
</style>
<script>
import * as CONFIG from '@/config.js'
export default {
    data() {
        return {
            tukangdata: [],
            loaddata: [],
            kecamatan: [],
            kelurahan: [],
            tukang: [],
            base_url: '',
            iskec: '',
            iskel: '',
        }
    },
    created() {
        document.title = 'INFO TUKANG'
        window.scrollTo(0, 0)
        // console.log(this.tukangdata)
        const baseurl = CONFIG.BASE_URL + '/api/'
        this.base_url = baseurl
        this.axios.get(baseurl + 'landing-dashboard').then((response) => {
            // console.log(response.data)
            const kec = response.data.metadata.messages.kecamatan
            const kel = response.data.metadata.messages.kelurahan
            let datakec = []
            let datakel = []
            kec.forEach(function (item) {
                datakec.push({ "id": item.id, "namakec": item.nama_kecamatan })
            })
            kel.forEach(function (item) {
                datakel.push({ "id": item.id, "kecid": item.kecamatan_id, "namakel": item.nama_kelurahan })
            })
            this.kecamatan = datakec
            this.kelurahan = datakel
            // console.log(this.kelurahan)
        })

        this.axios.get(baseurl + 'list-landing-tenaga-kerja').then((response) => {
            // console.log(response.data)
            this.tukang = response.data.metadata.messages
            // const kec = response.data.metadata.messages.kecamatan
            // let datakec = []
            // kec.forEach(function(item) {
            //     datakec.push({"id":item.id,"namakec":item.nama_kecamatan})
            // })
            // this.kecamatan = datakec
        })
    },
    methods: {
        loadwil(valuedata) {
            if (valuedata) {
                return valuedata;
            } else {
                return '-';
            }
        },
        itregex(value1, itsfunction) {
            let statusdata1 = false
            if (value1 == '') {
                statusdata1 = true
                // statusdata2 = true
            } else if (value1 == itsfunction.kecamatan) {
                statusdata1 = true
                // statusdata2 = true
            }
            return statusdata1
        },
        mycond(value1) {
            let datakel = []
            if (value1 != "") {
                let isid = ''
                this.kecamatan.forEach(isdatamasuk => {
                    if (isdatamasuk.namakec == value1) {
                        isid = isdatamasuk.id
                    }
                })

                this.kelurahan.forEach(datamasuk => {
                    if (isid == datamasuk.kecid) {
                        datakel.push({ "id": datamasuk.id, "kecid": datamasuk.kecid, "namakel": datamasuk.namakel })
                    }
                })
            }
            // console.log(datakel)
            return datakel
        }
    }
}
</script>